module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/choose-sourcedout/always-fresh-opportunities-5b4b4e7d2b659e23f664b63915c87bf9.png";